(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/game-package/assets/react/components/game-card/game-card-body.js') >= 0) return;  svs.modules.push('/modules/game-package/assets/react/components/game-card/game-card-body.js');

'use strict';

const Button = svs.ui.ReactButton;
const {
  useDispatch
} = ReactRedux;
const {
  useCallback
} = React;
const {
  isKeno
} = svs.numbergames.productMapping;
const {
  BallRowsWrapper
} = svs.numbergames.ball_row_helper;
const {
  CampaignInfo
} = svs.gamePackage.components;
const {
  huxflux
} = svs.gamePackage.redux.numbergamesSlice.actions;
const ballSize = productId => isKeno(productId) ? 150 : 200;
const GameCardBody = _ref => {
  let {
    game
  } = _ref;
  const {
    productId,
    boards,
    hasJoker,
    joker,
    isHuxfluxed,
    uniqueId
  } = game;
  const dispatch = useDispatch();
  const handleHuxflux = useCallback(e => {
    e.stopPropagation();
    dispatch(huxflux({
      uniqueId
    }));
  }, [dispatch, uniqueId]);
  return React.createElement(React.Fragment, null, React.createElement(BallRowsWrapper, {
    animateChanges: isHuxfluxed,
    options: {
      size: ballSize(productId)
    },
    items: boards.map(b => ({
      numbers: b.numbers.map(num => num.number),
      numbersExtra: b.extraNumbers && b.extraNumbers.map(num => num.number),
      kungKeno: b.hasKungKeno,
      productId: b.productId
    }))
  }), React.createElement(CampaignInfo, {
    uniqueId: uniqueId
  }), hasJoker && React.createElement(BallRowsWrapper, {
    animateChanges: isHuxfluxed,
    options: {
      size: ballSize(productId),
      description: new svs.tur.ball.row.extensions.Description({
        title: 'Joker'
      })
    },
    items: [{
      numbers: joker === null || joker === void 0 ? void 0 : joker.numbers.map(_ref2 => {
        let {
          number
        } = _ref2;
        return number;
      }),
      productId: 'Joker'
    }]
  }), React.createElement(Button, {
    className: "huxflux-button",
    transparent: true,
    onClick: handleHuxflux
  }, "Slumpa"));
};
svs.gamePackage.components.GameCardBody = GameCardBody;

 })(window);